<template>
  <div>
    <div class="fm-flex">
      <div
        style="width: 155px; min-width: 155px; align-self: flex-start"
        id="categoryCheckboxGroup"
      >
        <el-radio-group size="mini" v-model="showType" @input="showTypeInput">
          <el-radio-button label="list"
            ><i class="el-icon el-icon-s-operation fm-mr-5"></i
            >列表</el-radio-button
          >
          <el-radio-button label="card"
            ><i class="el-icon el-icon-s-grid fm-mr-5"></i>卡片</el-radio-button
          >
        </el-radio-group>
        <div
          :style="{
            height: rightHeight + 'px',
            'max-height': rightHeight + 'px',
            'overflow-y': 'auto',
          }"
          class="fm-mt-25"
        >
          <div
            class="categoryItem fm-pointer"
            :class="{
              'categoryItem-UnSelect':
                searchData.commodityCategoryIdList.length > 0,
              'categoryItem-Select':
                searchData.commodityCategoryIdList.length == 0,
            }"
            @click="selectCategory()"
          >
            <p class="fm-line-2" style="font-size: 14px">全部分类</p>
          </div>
          <div
            v-for="(category, index) in categoryList || []"
            :key="index"
            class="categoryItem fm-pointer"
            :class="{
              'categoryItem-UnSelect':
                searchData.commodityCategoryIdList.indexOf(category.id) <= -1,
              'categoryItem-Select':
                searchData.commodityCategoryIdList.indexOf(category.id) > -1,
            }"
            @click="selectCategory(category)"
          >
            <p class="fm-line-2" style="font-size: 14px">{{ category.name }}</p>
          </div>
        </div>
      </div>
      <div
        ref="commodityContainer"
        id="commodityContainer"
        style="width: 100%; min-width: 650px; align-self: flex-start"
        v-loading="searchLoading"
      >
        <el-form
          inline
          :model="searchData"
          v-hasPermi="['commodity:manage:query']"
          class="fm-ml-5"
        >
          <el-form-item>
            <el-input
              placeholder="名称/单位/规格/条码"
              clearable
              prefix-icon="el-icon-search"
              v-model="searchData.searchInputValue"
              style="width: 250px"
              @keyup.enter.native="changeAndSearch"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="在产状态">
            <EnumSelect
              enumName="CommodityProductionStatusEnum"
              placeholder="请选择商品在产状态"
              v-model="searchData.productionStatusEnumList"
              @change="changeAndSearch"
            ></EnumSelect>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              type="primary"
              size="mini"
              @click="changeAndSearch"
              :loading="searchLoading"
            >
              查询
            </el-button>
            <el-button
              icon="el-icon-refresh"
              size="mini"
              @click="resetAndSearch"
              :loading="searchLoading"
            >
              重置
            </el-button>
          </el-form-item>
        </el-form>
        <div v-if="showType == 'list'">
          <el-table
            v-loading="searchLoading"
            :data="searchRes && searchRes.data ? searchRes.data : []"
            stripe
            :row-key="
              (row) => {
                return row.id + row.lastEditTime;
              }
            "
            ref="refsTable"
            @sort-change="sortChange"
            :max-height="rightHeight"
          >
            <el-table-column
              label="商品图片"
              width="130"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope">
                <CommodityImage
                  :commodity="scope.row"
                  size="60px"
                ></CommodityImage>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="名称"
              min-width="150"
              align="left"
              header-align="center"
              sortable="custom"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content" style="max-width: 300px">
                    {{ scope.row.name }}
                  </div>
                  <span class="fm-line-3">{{ scope.row.name }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="productionStatusEnum.Desc"
              label="在产状态"
              width="100"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope">
                <span
                  v-fmtype="
                    $jsTool.getCommodityProductionType(
                      scope.row.productionStatusEnum
                    )
                  "
                  >{{ scope.row.productionStatusEnum.Desc }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="commodityCategory.name"
              label="商品信息"
              width="250"
              align="left"
              header-align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div>分类：{{ scope.row.commodityCategory.name }}</div>
                <div>单位：{{ scope.row.unit }}</div>
                <div>
                  商品类型：<span
                    v-fmtype="
                      $jsTool.getCommodityMultiSpecMarkType(
                        scope.row.multiSpecMark
                      )
                    "
                    >{{
                      scope.row.multiSpecMark ? "多规格商品" : "单规格商品"
                    }}</span
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="零售价"
              width="150"
              align="left"
              header-align="center"
              show-overflow-tooltip
              v-if="from == 'SaleOrder'"
            >
              <template slot-scope="scope">
                <fm-amount
                  slot="right"
                  :bold="false"
                  size="0.8rem"
                  :amount="scope.row.minBuyingPrice"
                  :nextAmount="scope.row.maxBuyingPrice"
                ></fm-amount>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              header-align="center"
              align="center"
              width="120"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.stop="selectCommodity(scope.row)"
                  type="text"
                  icon="el-icon-document"
                >
                  选择商品
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            v-if="searchRes && searchRes.pageInfo"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchRes.pageInfo.page"
            :page-sizes="[5, 10, 20, 50, 100]"
            :page-size="searchRes.pageInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="searchRes.total"
          >
          </el-pagination>
        </div>
        <div v-if="showType == 'card'">
          <div
            style="overflow-y: auto"
            :style="{
              height: rightHeight + 'px',
              'max-height': rightHeight + 'px',
            }"
          >
            <div>
              <el-card
                class="commodityCard"
                v-for="(item, index) in searchRes ? searchRes.data : []"
                :key="index"
                :style="{
                  margin: '0px 5px 10px 5px',
                }"
              >
                <div class="fm-pointer" @click="selectCommodity(item)">
                  <div class="fm-flex">
                    <CommodityImage
                      :commodity="item"
                      size="60px"
                      style="min-width: 60px"
                    ></CommodityImage>
                    <div class="fm-ml-5">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        placement="top-start"
                      >
                        <div slot="content" style="max-width: 300px">
                          {{ item.name }}
                        </div>
                        <span class="fm-line-1" style="font-weight: bold">{{
                          item.name
                        }}</span>
                      </el-tooltip>
                      <div class="fm-flex fm-mt-3">
                        <p
                          size="mini"
                          v-fmtype="
                            $jsTool.getCommodityProductionType(
                              item.productionStatusEnum
                            )
                          "
                          style="font-size: 0.8rem"
                        >
                          {{ item.productionStatusEnum.Desc }}
                        </p>
                        <p
                          class="fm-ml-5"
                          size="mini"
                          v-fmtype="
                            $jsTool.getCommodityMultiSpecMarkType(
                              item.multiSpecMark
                            )
                          "
                          style="font-size: 0.8rem"
                        >
                          {{ item.multiSpecMark ? "多规格商品" : "单规格商品" }}
                        </p>
                      </div>
                      <p class="fm-line-1" style="font-size: 0.8rem">
                        分类：{{ item.commodityCategory.name }}
                      </p>
                      <p class="fm-line-1" style="font-size: 0.8rem">
                        单位：{{ item.unit }}
                      </p>
                    </div>
                  </div>
                  <div class="fm-flex fm-mt-3" v-if="from == 'SaleOrder'">
                    <p style="font-size: 0.8rem">零售价：</p>
                    <fm-amount
                      :bold="false"
                      size="0.8rem"
                      :amount="item.minBuyingPrice"
                      :nextAmount="item.maxBuyingPrice"
                    ></fm-amount>
                  </div>
                </div>
              </el-card>
            </div>
            <div style="clear: both"></div>
            <el-empty
              description="暂无符合条件的商品"
              v-if="!loadMore.show"
            ></el-empty>
          </div>
          <el-pagination
            v-if="searchRes && searchRes.pageInfo"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchRes.pageInfo.page"
            :page-sizes="[cardPageSize]"
            :page-size="searchRes.pageInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="searchRes.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="选择规格"
      :visible="selectCommodityPopupShow"
      append-to-body
      width="600px"
      @close="selectCommodityPopupShow = false"
    >
      <el-row>
        <el-col :span="3">
          <CommodityImage
            :commodity="nowCommodity"
            :commoditySpec="nowCommoditySpec"
            size="60px"
          >
          </CommodityImage>
        </el-col>
        <el-col :span="20">
          <p>
            商品：<span style="font-weight: bold">{{ nowCommodity.name }}</span>
          </p>
          <p>
            <span v-fmtype="popupSubTitle.type">{{ popupSubTitle.title }}</span
            ><span
              v-fmtype="popupSubTitle.type"
              style="font-weight: bold"
              v-if="popupSubTitle.text"
              >{{ popupSubTitle.text }}</span
            >
          </p>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <div class="fm-subtitle" style="color: var(--fm-primary-text-color)">
        规格{{ " (" + (canSelectSpecList.length || "暂无") + ")" }}
      </div>
      <div
        style="
          min-height: 20px;
          max-height: 200px;
          overflow-y: auto;
          display: flex;
          flex-flow: row wrap;
        "
      >
        <el-tag
          v-for="(item, index) in canSelectSpecList"
          :key="'spec' + index"
          :effect="
            nowCommoditySpec && nowCommoditySpec.id == item.id
              ? 'dark'
              : 'light'
          "
          :type="
            nowCommoditySpec && nowCommoditySpec.id == item.id
              ? 'primary'
              : item.type
          "
          class="fm-margin-right-10 fm-margin-top-10 fm-pointer"
          style="max-width: 100%"
          @click="clickCommoditySpecTag(item)"
        >
          <div class="fm-flex">
            <CommodityImage
              class="fm-mr-5"
              :emptyShow="false"
              :commoditySpec="item"
              size="1.5em"
            ></CommodityImage>
            {{ item.label }}
          </div>
        </el-tag>
      </div>

      <el-divider></el-divider>
      <el-row v-if="from == 'SaleOrder'">
        <el-tooltip effect="dark" content="" placement="top-start">
          <div slot="content" style="line-height: 1.5em">
            <div style="font-weight: bold">数量说明</div>
            若商品规格已停产，则销售数量不得大于规格的可用库存<br />若在产则仅提示可用库存(现货数量)，并可超量预售
          </div>
          <i class="el-icon el-icon-question fm-mr-5"></i>
        </el-tooltip>

        <span class="fm-mr-10" style="color: var(--fm-primary-text-color)"
          >购买数量</span
        >
        <FmNumberDigitBox
          v-model="nowQuantity"
          label="数量"
          size="small"
          :precision="0"
          :min="0"
          :max="
            nowCommoditySpec && !nowCommoditySpec.inProduction
              ? nowCommoditySpec.availableQuantity
              : 1000
          "
          @change="
            (e) => {
              changeItemQuantityFromList(e, {
                commoditySpecId: nowCommoditySpec.id,
              });
            }
          "
          v-if="
            (nowCommoditySpec && nowCommoditySpec.inProduction) ||
            (nowCommoditySpec &&
              !nowCommoditySpec.inProduction &&
              nowCommoditySpec.availableQuantity > 0)
          "
        ></FmNumberDigitBox>
        <template v-if="nowCommoditySpec">
          <span
            class="fm-ml-5"
            v-fmtype="'info'"
            style="font-size: 0.8rem"
            v-if="nowCommoditySpec.inProduction"
            >{{ "现货 " + nowCommoditySpec.availableQuantity + " 件" }}</span
          >
          <span
            class="fm-ml-5"
            v-fmtype="'warning'"
            style="font-size: 0.8rem"
            v-if="
              !nowCommoditySpec.inProduction &&
              nowCommoditySpec.availableQuantity > 0
            "
            >{{
              "最多可卖 " + nowCommoditySpec.availableQuantity + " 件"
            }}</span
          >
          <span
            class="fm-ml-5"
            v-fmtype="'warning'"
            style="font-size: 0.8rem"
            v-if="
              !nowCommoditySpec.inProduction &&
              nowCommoditySpec.availableQuantity <= 0
            "
            >当前规格已停产且已售空</span
          >
        </template>
      </el-row>
      <el-row v-if="from == 'PurchaseOrder'">
        <span class="fm-mr-10" style="color: var(--fm-primary-text-color)"
          >购买数量</span
        >
        <FmNumberDigitBox
          v-model="nowQuantity"
          label="数量"
          size="small"
          :min="0"
          :max="1000"
          @change="
            (e) => {
              changeItemQuantityFromList(e, {
                commoditySpecId: nowCommoditySpec.id,
              });
            }
          "
          v-if="nowCommoditySpec"
        ></FmNumberDigitBox>
        <template v-if="nowCommoditySpec">
          <span class="fm-ml-5" v-fmtype="'info'" style="font-size: 0.8rem">{{
            "当前可用库存 " + nowCommoditySpec.availableQuantity
          }}</span>
          <span
            class="fm-ml-5"
            v-fmtype="'warning'"
            style="font-size: 0.8rem"
            v-if="!nowCommoditySpec.inProduction"
            >{{ "当前规格已停产,请确认是否继续采购 " }}</span
          >
        </template>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="selectCommodityPopupShow = false">取 消</el-button>
        <el-button
          type="primary"
          :disabled="!(nowCommoditySpec && nowQuantity > 0)"
          @click="selectCommoditySpec"
        >
          确认选择
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Rterpv2WebCommoditySelect",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    from: {
      // 来源，SaleOrder 销售单|PurchaseOrder 采购单 | CommodityLossOrder 报损单
      type: String,
      default: null,
      require: true,
    },
    selectList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    rightHeight: {
      type: [String, Number],
      default: 480,
    },
  },
  watch: {
    show: {
      handler(newVal) {
        this.searchLoading = this.$options.data().searchLoading;
        this.searchData = this.$options.data().searchData;
        this.commodityCategory = this.$options.data().commodityCategory;
        this.searchParam = this.$options.data().searchParam;
        this.searchRes = this.$options.data().searchRes;
        let type = this.$storageUtil.getCommoditySelectType();
        if (type && type == "card") {
          this.showType = "card";
        }
        if (this.show) {
          setTimeout(() => {
            this.showTypeInput();
            this.flushCategoryList();
          }, 100);
        }
      },
      immediate: true,
    },
    rightHeight: {
      handler(newVal) {
        this.initPageSize();
      },
      immediate: false,
    },
  },
  computed: {
    popupSubTitle() {
      let res = {
        title: "请选择规格",
        type: "",
        text: "",
      };
      if (this.nowCommoditySpec && this.nowCommoditySpec.id) {
        res.title = "规格：";
        res.text = this.nowCommoditySpec.specName;
        res.type = "";
      } else {
        res.title = "请选择规格";
        res.type = "warning";
      }
      return res;
    },
    canSelectSpecList() {
      if (this.nowCommodity) {
        let specList = this.nowCommodity.commoditySpecList.filter(
          (d) => !d.frozen
        );
        return specList
          .map((d) => {
            let type = "primary";
            if (!d.inProduction) {
              type = d.availableQuantity <= 0 ? "info" : "danger";
            }
            let desc = "";
            if (this.from == "SaleOrder") {
              desc += " ￥" + Number(d.buyingPrice).toFixed(2);
              if (!d.inProduction) {
                desc +=
                  d.availableQuantity <= 0 ? " (已停产且已售空)" : " (已停产)";
              }
            } else if (this.from == "PurchaseOrder") {
              desc += " ￥" + Number(d.retailPrice).toFixed(2);
              if (!d.inProduction) {
                desc += " (已停产)";
              }
              type = "warning";
            } else if (this.from == "CommodityLossOrder") {
              if (!d.inProduction) {
                desc += " (已停产)";
              }
            }
            return {
              ...d,
              label: d.specName + desc,
              type: type,
              canSale: d.inProduction || d.availableQuantity > 0,
            };
          })
          .sort((a, b) => {
            if (a.canSale != b.canSale) {
              return b.canSale - a.canSale;
            }
            if (a.inProduction != b.inProduction) {
              return b.inProduction - a.inProduction;
            }
            return a.name - b.name;
          });
      }
      return [];
    },
  },
  data() {
    return {
      showType: "list",

      searchLoading: false,
      searchData: {
        searchInputValue: null,
        commodityCategoryIdList: [],
        productionStatusEnumList: null,
      },

      commodityCategory: {},

      searchParam: {
        quickSearchInfoList: [
          {
            columns: ["name", "unit", "specName", "specBarCode"],
            quickSearchValue: null,
          },
        ],
        commodityCategoryIdList: [],
        productionStatusEnumList: [],
        pageInfo: {
          page: 1,
          pageSize: 10,
        },
        sortInfo: null,
      },
      searchRes: {},

      // 当前选择的商品
      nowCommodity: {
        imageNameList: [],
        commoditySpecList: [{}],
      },
      // 当前选择的商品规格
      nowCommoditySpec: null,
      // 当前选择的商品数量
      nowQuantity: 1,

      selectCommodityPopupShow: false,

      categoryList: [],
      checkAll: false,
      isIndeterminate: true,

      // 加载更多
      loadMore: {
        status: "loadmore",
        show: false,
      },

      cardPageSize: 16,
      contentMaxHeight: 480,

      timer: null,
    };
  },

  mounted() {
    const resizeObserver = new ResizeObserver((entries) => {
      //回调
      this.handleResize(entries);
    });
    resizeObserver.observe(this.$refs.commodityContainer);
  },

  methods: {
    handleResize(entries) {
      this.initPageSize();
    },
    initPageSize() {
      if (
        !document.getElementById("commodityContainer") ||
        document.getElementsByClassName("commodityCard").length == 0
      ) {
        return 0;
      }
      if (this.rightHeight == "480px") {
        return 16;
      }
      let commodityContainer = document.getElementById("commodityContainer");
      let firstCommodity = document.getElementsByClassName("commodityCard")[0];
      let width = window
        .getComputedStyle(commodityContainer)
        .width.replace("px", "");
      let height =
        window.getComputedStyle(commodityContainer).height.replace("px", "") -
        90;
      this.contentMaxHeight = height;
      let unitHeight =
        Number(
          window.getComputedStyle(firstCommodity).height.replace("px", "")
        ) + 10;
      let rowCount = parseInt(width / 210);
      let lineCount = parseInt(height / unitHeight);
      let cardPageSize = rowCount * lineCount;
      if (cardPageSize != this.cardPageSize) {
        this.secondSearch();
      }
      this.cardPageSize = cardPageSize;
      return this.cardPageSize;
    },

    secondSearch() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.search(true);
      }, 1000);
    },

    initData() {
      this.searchLoading = this.$options.data().searchLoading;
      this.searchData = this.$options.data().searchData;
      this.commodityCategory = this.$options.data().commodityCategory;
      this.searchParam = this.$options.data().searchParam;
      this.searchRes = this.$options.data().searchRes;
      let type = this.$storageUtil.getCommoditySelectType();
      if (type && type == "card") {
        this.showType = "card";
      }
      if (this.show) {
        setTimeout(() => {
          this.showTypeInput();
          this.flushCategoryList();
        }, 100);
      }
    },
    showTypeInput() {
      this.$storageUtil.setCommoditySelectType(this.showType);
      this.search(true);
    },

    async flushCategoryList() {
      let res = await this.$api.commodityCategory_findListForFilterCommodity({
        showFailMessage: false,
        showLoading: true,
        loadingParam: {
          target: "#categoryCheckboxGroup",
          lock: true,
        },
      });
      if (res && res.success) {
        this.categoryList = res.data;
        this.$forceUpdate();
      }
    },
    handleCheckAllChange(val) {
      this.searchData.commodityCategoryIdList = val
        ? this.categoryList.map((d) => d.id)
        : [];
      this.isIndeterminate = false;
      this.changeAndSearch();
    },
    selectCategory(category) {
      this.searchData.commodityCategoryIdList = category ? [category.id] : [];
      this.changeAndSearch();
      // let id = category.id;
      // let index = this.searchData.commodityCategoryIdList.indexOf(id);
      // let selectIdList = this.searchData.commodityCategoryIdList;
      // if (index > -1) {
      //   selectIdList.splice(index, 1);
      // } else {
      //   selectIdList.push(id);
      // }
      // this.handleCheckedCategoryChange(selectIdList);
    },
    handleCheckedCategoryChange(value = []) {
      let checkedCount = value.length;
      this.searchData.commodityCategoryIdList = value;
      this.checkAll = checkedCount == this.categoryList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.categoryList.length;
      this.changeAndSearch();
    },

    // 已选商品的价格详情
    getAmountLabel(item) {
      if (this.from == "SaleOrder") {
        return (
          (item.buyingPrice || item.commoditySpec.buyingPrice) +
          " * " +
          item.itemQuantity +
          (item.disCountAmount == 0 ? "" : " - " + item.disCountAmount) +
          " = " +
          item.itemAmount
        );
      } else if (this.from == "PurchaseOrder") {
        return (
          (item.retailPrice || item.commoditySpec.retailPrice) +
          " * " +
          item.itemQuantity +
          (item.disCountAmount == 0 ? "" : " - " + item.disCountAmount) +
          " = " +
          item.itemAmount
        );
      }
    },
    showAmountTips(item) {
      this.$jsTool.showTipsModal(
        "金额详情",
        (this.from == "SaleOrder" ? "零售价：" : "进货价：") +
          (this.from == "SaleOrder"
            ? Number(
                item.buyingPrice || item.commoditySpec.buyingPrice
              ).toFixed(2)
            : Number(
                item.retailPrice || item.commoditySpec.retailPrice
              ).toFixed(2)) +
          "\n" +
          "数量：" +
          item.itemQuantity +
          "\n" +
          "折扣金额：" +
          item.disCountAmount +
          "\n" +
          "金额合计：" +
          item.itemAmount +
          "\n" +
          "计算公式：" +
          (this.from == "SaleOrder"
            ? Number(
                item.buyingPrice || item.commoditySpec.buyingPrice
              ).toFixed(2)
            : Number(
                item.retailPrice || item.commoditySpec.retailPrice
              ).toFixed(2)) +
          " * " +
          item.itemQuantity +
          " - " +
          item.disCountAmount +
          " = " +
          item.itemAmount
      );
    },
    selectCommodity(item) {
      this.nowCommodity = item;
      // 单规格商品直接选择
      if (!item.multiSpecMark) {
        let commoditySpec = this.canSelectSpecList[0];
        // 默认选择第一个，选择后返回
        this.nowCommoditySpec = this.canSelectSpecList[0];
        // 如果已经选择则直接返回
        let index = this.selectList.findIndex(
          (d) => d.commoditySpecId == commoditySpec.id
        );
        if (index > -1) {
          let commoditySpec = this.selectList[index].commoditySpec;
          if (
            this.from == "SaleOrder" &&
            !commoditySpec.inProduction &&
            this.selectList[index].itemQuantity >=
              commoditySpec.availableQuantity
          ) {
            this.$message.error(
              "此商品已停产，所选数量 " +
                this.selectList[index].itemQuantity +
                " 已经大于等于该规格的可用库存 " +
                commoditySpec.availableQuantity +
                "，无法继续选择"
            );
          } else {
            this.nowQuantity = this.selectList[index].itemQuantity + 1;
            this.selectCommoditySpec();
          }
          return;
        }
        this.nowQuantity = 1;
        this.selectCommoditySpec();
        return;
      }
      this.nowCommoditySpec = null;
      let index = this.selectList.findIndex((d) => d.commodityId == item.id);
      if (index > -1) {
        this.nowCommoditySpec = this.canSelectSpecList.filter(
          (d) => d.id == this.selectList[index].commoditySpecId
        )[0];
        this.nowQuantity = this.selectList[index].itemQuantity;
      } else {
        if (this.canSelectSpecList && this.canSelectSpecList.length > 0) {
          // this.nowCommoditySpec = this.canSelectSpecList[0];
          this.nowQuantity = 1;
        } else {
          this.$message.error("此商品下没有可选择的规格,请选择其他商品");
          return;
        }
      }
      this.selectCommodityPopupShow = true;
    },

    // 点击商品规格tag
    clickCommoditySpecTag(item) {
      if (this.from == "SaleOrder") {
        if (!item.canSale) {
          this.$message.error("所选规格已全部停产且已全部售空,请选择其他商品");
          return;
        }
      } else if (this.from == "PurchaseOrder") {
        if (!item.inProduction) {
          this.$message.error("所选规格已停产,请确认是否继续采购此规格");
        }
      }
      this.nowCommoditySpec = item;
      let index = this.selectList.findIndex(
        (d) => d.commoditySpecId == item.id
      );
      if (index > -1) {
        this.nowQuantity = this.selectList[index].itemQuantity;
      } else {
        this.nowQuantity = 1;
      }
    },
    // 选择商品规格
    selectCommoditySpec() {
      try {
        if (!this.nowCommodity || !this.nowCommodity.id) {
          this.$message.error("请选择商品");
          return;
        }
        if (!this.nowCommoditySpec || !this.nowCommoditySpec.id) {
          this.$message.error("请选择规格");
          return;
        }
        if (!this.nowQuantity || this.nowQuantity < 0) {
          this.$message.error("请输入数量");
          return;
        }
        if (this.from == "SaleOrder") {
          if (!this.nowCommoditySpec.canSale) {
            this.$message.error(
              "所选规格已全部停产且已全部售空,请选择其他商品"
            );
            return;
          }
          if (
            !this.nowCommoditySpec.inProduction &&
            this.nowQuantity > this.nowCommoditySpec.availableQuantity
          ) {
            this.$message.error(
              "所选数量 " +
                this.nowQuantity +
                " 超出规格可用库存 " +
                this.nowCommoditySpec.availableQuantity
            );
            return;
          }
          let index = this.selectList.findIndex(
            (d) => d.commoditySpecId == this.nowCommoditySpec.id
          );
          let itemNo =
            index > -1
              ? this.selectList[index].itemNo
              : this.selectList && this.selectList.length > 0
              ? this.selectList[this.selectList.length - 1].itemNo + 1
              : 1;
          let itemAmount = this.$jsTool.multi(
            this.nowCommoditySpec.buyingPrice,
            this.nowQuantity
          );
          let item = {
            buyingPrice: this.nowCommoditySpec.buyingPrice,
            itemNo: itemNo,
            commodityId: this.nowCommodity.id,
            commodity: this.nowCommodity,
            commoditySpecId: this.nowCommoditySpec.id,
            commoditySpec: this.nowCommoditySpec,
            itemQuantity: this.nowQuantity,
            commodityBuyingTotalAmount: itemAmount,
            disCountAmount: 0,
            itemAmount: itemAmount,
          };
          if (index > -1) {
            let res = this.selectList;
            res.splice(index, 1, item);
            this.confirmSelect(res);
          } else {
            this.confirmSelect(this.selectList.concat(item));
          }
          // this.selectCommodityPopupShow = false;
        } else if (this.from == "PurchaseOrder") {
          let that = this;
          if (that.nowCommoditySpec.inProduction) {
            let index = that.selectList.findIndex(
              (d) => d.commoditySpecId == that.nowCommoditySpec.id
            );
            let itemNo =
              index > -1
                ? that.selectList[index].itemNo
                : that.selectList && that.selectList.length > 0
                ? that.selectList[that.selectList.length - 1].itemNo + 1
                : 1;
            let itemAmount = that.$jsTool.multi(
              that.nowCommoditySpec.retailPrice,
              that.nowQuantity
            );
            let item = {
              itemNo: itemNo,
              retailPrice: that.nowCommoditySpec.retailPrice,
              commodityId: that.nowCommodity.id,
              commodity: that.nowCommodity,
              commoditySpecId: that.nowCommoditySpec.id,
              commoditySpec: that.nowCommoditySpec,
              itemQuantity: that.nowQuantity,
              commodityRetailTotalAmount: itemAmount,
              disCountAmount: 0,
              itemAmount: itemAmount,
            };
            if (index > -1) {
              let res = that.selectList;
              res.splice(index, 1, item);
              that.confirmSelect(res);
            } else {
              that.confirmSelect(that.selectList.concat(item));
            }
            //   that.selectCommodityPopupShow = false;
          } else {
            this.$confirm("所选规格已停产，是否继续采购此规格", "操作提醒", {
              confirmButtonText: "继续",
              closeOnClickModal: false,
              closeOnPressEscape: false,
              closeOnHashChange: false,
            }).then(() => {
              try {
                let index = that.selectList.findIndex(
                  (d) => d.commoditySpecId == that.nowCommoditySpec.id
                );
                let itemNo =
                  index > -1
                    ? that.selectList[index].itemNo
                    : that.selectList && that.selectList.length > 0
                    ? that.selectList[that.selectList.length - 1].itemNo + 1
                    : 1;
                let itemAmount = that.$jsTool.multi(
                  that.nowCommoditySpec.retailPrice,
                  that.nowQuantity
                );
                let item = {
                  itemNo: itemNo,
                  retailPrice: that.nowCommoditySpec.retailPrice,
                  commodityId: that.nowCommodity.id,
                  commodity: that.nowCommodity,
                  commoditySpecId: that.nowCommoditySpec.id,
                  commoditySpec: that.nowCommoditySpec,
                  itemQuantity: that.nowQuantity,
                  commodityRetailTotalAmount: itemAmount,
                  disCountAmount: 0,
                  itemAmount: itemAmount,
                };
                if (index > -1) {
                  // that.selectList.splice(index, 1, item);
                  that.confirmSelect(that.selectList.slice(index, 1, item));
                } else {
                  // that.selectList.push(item);
                  that.confirmSelect(that.selectList.concat(item));
                }
                //   that.selectCommodityPopupShow = false;
              } finally {
              }
            });
          }
        } else if (this.from == "CommodityLossOrder") {
          let index = this.selectList.findIndex(
            (d) => d.commoditySpecId == this.nowCommoditySpec.id
          );
          let itemNo =
            index > -1
              ? this.selectList[index].itemNo
              : this.selectList && this.selectList.length > 0
              ? this.selectList[this.selectList.length - 1].itemNo + 1
              : 1;
          let item = {
            itemNo: itemNo,
            commodityId: this.nowCommodity.id,
            commodity: this.nowCommodity,
            commoditySpecId: this.nowCommoditySpec.id,
            commoditySpec: this.nowCommoditySpec,
            itemQuantity: this.nowQuantity,
          };
          if (index > -1) {
            let res = that.selectList;
            res.splice(index, 1, item);
            this.confirmSelect(res);
          } else {
            this.confirmSelect(this.selectList.concat(item));
          }
        }
        this.selectCommodityPopupShow = false;
      } finally {
      }
    },
    // 确认选择
    confirmSelect(list) {
      let that = this;
      if (!list || list.length == 0) {
        this.$confirm(
          "尚未选择商品，继续确认将会移除单据中原已选择的商品，是否继续？",
          "操作提醒",
          {
            confirmButtonText: "继续确认",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false,
            closeOnHashChange: false,
          }
        )
          .then(() => {
            this.$emit("selectCommodity", list || []);
          })
          .catch(() => {});
      } else {
        this.$emit("selectCommodity", list || []);
      }
    },
    changeItemQuantityFromList(value, { commoditySpecId }) {
      // 如果index < 0，则代表是新商品，无需进行处理
      if (
        !(
          commoditySpecId &&
          this.selectList.findIndex(
            (d) => d.commoditySpecId == commoditySpecId
          ) > -1
        )
      ) {
        return;
      }
      let that = this;
      if (value <= 0) {
        this.$confirm("是否移除所选商品?", "操作提醒", {
          confirmButtonText: "移除",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        })
          .then(() => {
            that.nowCommoditySpec = {};
            that.selectList.splice(
              that.selectList.findIndex(
                (d) => d.commoditySpecId == commoditySpecId
              ),
              1
            );
            that.selectCommodityPopupShow = false;
          })
          .catch(() => {
            that.changeItemQuantityFromList(1, {
              commoditySpecId,
            });
            that.nowQuantity = 1;
          });
      }
    },

    handleSizeChange(val) {
      this.searchParam.pageInfo.pageSize = val;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    handleCurrentChange(val) {
      this.searchParam.pageInfo.page = val;
      this.search(false, {
        showSuccessMessage: true,
      });
    },
    changeAndSearch() {
      this.searchParam.quickSearchInfoList[0].quickSearchValue =
        this.searchData.searchInputValue;
      this.searchParam.commodityCategoryIdList =
        this.searchData.commodityCategoryIdList;
      this.searchParam.productionStatusEnumList =
        this.searchData.productionStatusEnumList;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    resetAndSearch() {
      this.searchData = this.$options.data().searchData;
      this.changeAndSearch();
    },
    sortChange(val) {
      this.searchParam.sortInfo =
        val && val.order
          ? {
              columnName: val.prop,
              order: val.order.replace("ending", "").toUpperCase(),
            }
          : null;
      this.search(true, {
        showSuccessMessage: true,
      });
    },
    async search(init, args) {
      this.loadMore.show = true;
      this.searchLoading = true;
      if (init) {
        this.searchParam.pageInfo.page = 1;
        this.searchParam.pageInfo.pageSize =
          this.showType == "card" ? this.cardPageSize : 10;
      }
      this.loadMore.status = "loading";
      let requestRes = await this.$api.commodity_findPageForSelect(
        this.searchParam,
        args
      );
      if (requestRes && requestRes.success) {
        this.searchRes = requestRes;
        this.searchRes.pageInfo = requestRes.pageInfo;
        this.$nextTick(() => {
          if (this.$refs.refsTable) {
            this.$refs.refsTable.doLayout();
          }
        });
      }
      this.loadMore.status =
        requestRes && requestRes.success && requestRes.hasMore
          ? "loadmore"
          : "nomore";
      if (requestRes.pageCount == 0) {
        this.searchRes = null;
        this.loadMore.show = false;
      } else {
        this.loadMore.show = true;
      }
      setTimeout(() => {
        this.searchLoading = false;
      }, 200);
    },
  },
};
</script>

<style scoped>
.commodityCard {
  float: left;
  width: 200px;
  margin-bottom: 10px;
}

.commodityCard >>> .el-card__body {
  padding: 10px;
}

.categoryItem {
  padding: 1em 0 1em 5px;
  margin-bottom: 2px;
  border-radius: 5px 0 0 5px;
}

.categoryItem-UnSelect {
  background: var(--fm-primary-lighter-color);
}

.categoryItem-Select {
  background: var(--fm-primary-color);
  color: white;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/CommoditySelect.vue